import { createAction } from 'typesafe-actions';
import {
    CreateOrderResponse,
    ListOrderRespone,
    OrderUpsell,
    OrderUserInfo,
    SubscriptionUpSellPayload,
} from '@lib/state/Order/types';
import { Coupon } from '@lib/domain/coupon';
import { ActionTypes, OrderCheck } from '@lib/domain/order';
import { createActionTypePrefixFormat } from '../common';

const typePrefixFormat = createActionTypePrefixFormat('User');

/* ------------- action creators ------------- */
export const getOrders = createAction(
    typePrefixFormat('GET_ORDERS'),
    (orders: ListOrderRespone) => ({
        ...orders,
    }), // payload creator
)();

export const createOrder = createAction(
    typePrefixFormat('CREATE_ORDER'),
    (order: CreateOrderResponse, isNew?: boolean) => ({
        orderInfo: order,
        isNew,
    }),
)();

export const addOrderIdNotLoggedIn = createAction(
    typePrefixFormat('ADD_ORDER_ID_NOT_LOGGED_IN'),
    (orderId: string | string[], merged?: boolean) => ({
        orderId,
        merged,
    }),
)();

export const removeOrderIds = createAction(
    typePrefixFormat('REMOVE_ORDER_IDS'),
)();

export const setIsNewOrder = createAction(
    typePrefixFormat('SET_IS_NEW_ORDER'),
    (isNew: boolean) => ({ isNew }),
)();

export const checkOrder = createAction(
    typePrefixFormat('CHECK_ORDER'),
    (checkedList: OrderCheck[]) => ({ checkedList }),
)();

export const setCheckPosts = createAction(
    typePrefixFormat('SET_CHECK_POSTS'),
    (checkedPosts: Record<string, Record<ActionTypes, number>>) => ({
        checkedPosts,
    }),
)();

export const setPageIndex = createAction(
    typePrefixFormat('SET_PAGE_INDEX'),
    (pageIndex: number) => ({ pageIndex }),
)();

export const orderComplete = createAction(
    typePrefixFormat('ORDER_COMPLETE'),
    (payload) => payload,
);

export const setChannel = createAction(
    typePrefixFormat('SET_CHANNEL'),
    (payload: string) => payload,
)();

export const setOrderUserInfo = createAction(
    typePrefixFormat('SET_ORDER_USER_INFO'),
    (payload: OrderUserInfo | null) => payload,
)();

export const setUpsell = createAction(
    typePrefixFormat('SET_UPSELL'),
    (payload: OrderUpsell) => payload,
)();

export const setLoading = createAction(
    typePrefixFormat('SET_LOADING'),
    (payload: boolean) => payload,
)();

export const setIsOrderCreated = createAction(
    typePrefixFormat('SET_IS_ORDER_CREATED'),
    (payload: boolean) => payload,
)();

export const setCoupon = createAction(
    typePrefixFormat('SET_IS_APPLY_COUPON'),
    (payload: Coupon | null) => payload,
)();

export const setSubscription = createAction(
    typePrefixFormat('SET_SUBSCRIPTION'),
    (payload: SubscriptionUpSellPayload) => payload,
)();

export const setTotal = createAction(
    typePrefixFormat('SET_TOTAL'),
    (payload: number) => payload,
)();
export const setDisabledSubscription = createAction(
    typePrefixFormat('SET_DISABLED_SUBSCRIPTION'),
    (payload: boolean) => payload,
)();
export const setCheckoutPaymentId = createAction(
    typePrefixFormat('SET_CHECKOUT_PAYMENT_ID'),
    (payload: string) => payload,
)();
export const setCheckoutOrderId = createAction(
    typePrefixFormat('SET_CHECKOUT_ORDER_ID'),
    (payload: string) => payload,
)();

export type OrderActions = ReturnType<typeof getOrders> &
    ReturnType<typeof createOrder> &
    ReturnType<typeof addOrderIdNotLoggedIn> &
    ReturnType<typeof setIsNewOrder> &
    ReturnType<typeof checkOrder> &
    ReturnType<typeof setCheckPosts> &
    ReturnType<typeof setPageIndex> &
    ReturnType<typeof setChannel> &
    ReturnType<typeof setOrderUserInfo> &
    ReturnType<typeof setUpsell> &
    ReturnType<typeof setLoading> &
    ReturnType<typeof setIsOrderCreated> &
    ReturnType<typeof setCoupon> &
    ReturnType<typeof setSubscription> &
    ReturnType<typeof setDisabledSubscription> &
    ReturnType<typeof setCheckoutPaymentId> &
    ReturnType<typeof setCheckoutOrderId>;
